<template>
    <div class="main-header-con" v-expend>
        <div class="main-header">
            <div class="navicon-con">
                <Icon type="md-menu" size="24" @click="toggle" ></Icon>
            </div>
            <div class="header-middle-con">
                <div class="main-breadcrumb">
                    <Breadcrumb>
                        <BreadcrumbItem   v-for="item in currentPath"  :href="item.path"  :key="item.id">
                            <Icon :type="item.icon"> </Icon> {{item.name}}
                        </BreadcrumbItem>
                    </Breadcrumb>
                </div>
            </div>
            <div class="header-avator-con" v-if="info!=undefined">
                <div class="user-dropdown-menu-con">
                    <Row type="flex" justify="end" align="middle" class="user-dropdown-innercon">
                        <Dropdown transfer trigger="click" @on-click="SelectedDropDownItem">
                            <a href="javascript:void(0)">
                                <span class="main-user-name" style="margin-top:-5px">[{{ info.username }}]  </span>
                                <Icon type="md-arrow-dropdown"  size="20"/>
                            </a>
                            <DropdownMenu transfer slot="list">
                                <DropdownItem name="accInfo"  >
                                    账号设置
                                </DropdownItem>
                                <DropdownItem name="adminSet"  >
                                    后台设置
                                </DropdownItem>
                                <DropdownItem name="logOff" divided>
                                    退出登录
                                </DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                        <avator style="margin-right:8px" v-if="info['avatar']==undefined" :text="info.username.substring(0,1)"/>
                        <avator style="margin-right:8px" v-else :src="info.avatar.url"/>
                    </Row>
                </div>
            </div>
        </div>
        <div class="tags-con">
            <tag-list/>
        </div>
        
    </div>
</template>

<script>

import Avator from '@/components/avator'
import TagList from '@/components/tags'
import {mapActions,mapGetters,mapState} from 'vuex'
export default {
    components:{Avator,TagList},
    
    computed:{
        ...mapGetters('user/',['info']),
        currentPath(){
            var rs= [
                { path:'/',name:'首页',icon:'md-speedometer' }
            ];
            return rs;
        }
                

    },
    methods:{
        ...mapActions('app/',['toggle']),
        ...mapActions('user/',['logoff']),
        SelectedDropDownItem(name){
            if (name==='logOff')
                this.logoff();
                location.reload();
            if (name==='adminSet'){
                let routeData = this.$router.resolve({
                    name: "dashboard",
                    params:{domain:this.$route.params.domain,endpoint:'admin'}
                });
                window.open(routeData.href, '_blank');
            }
                
        }
    },
}
</script>

